import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import ScheduledOrderDetail from '@features/client/scheduled-orders/ScheduledOrderDetail.tsx';
import { PermissionTypesEnum } from '@mock/Permissions.ts';
import { OrganizationFeatureEnum } from '@mock/OrganizationFeatures.ts';

export const Route = createFileRoute('/c/$orgId/$portalId/scheduled-orders/$scheduledOrderId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { scheduledOrderId } = Route.useParams();

  return (
    <UserLayout
      oneOfPermission={[PermissionTypesEnum.CLIENT_SCHEDULED_ORDER_READ]}
      requiredFeature={OrganizationFeatureEnum.SCHEDULED_ORDERS}
    >
      <div className="max-w-[1200px] mx-auto">
        <ScheduledOrderDetail scheduledOrderId={Number(scheduledOrderId)} />
      </div>
    </UserLayout>
  );
}
